export const baseUrl ='https://api.themoviedb.org/3';
export const API_KEY ="923700a036a8ad3b71ec0668cd192390";
 export const imageUrl = "https://image.tmdb.org/t/p/original";